import { Textfield } from '@digdir/designsystemet-react';
import { useTranslation } from 'react-i18next';

import { useOmBoligenFormContext } from '../utils';
import { useOmBoligenValidation } from '../hooks/useOmBoligenValidation';

export const ByggearInput = () => {
  const { register, formState } = useOmBoligenFormContext();
  const { t } = useTranslation();
  const { validateYear } = useOmBoligenValidation();

  const error = formState.errors.bygginfo?.year?.message;

  return (
    <Textfield
      inputMode="numeric"
      maxLength={4}
      label={t('register.bygningsdetaljer.byggear.label')}
      error={error}
      {...register('bygginfo.year', {
        validate: validateYear
      })}
    />
  );
};
